import React from 'react';
import { motion } from 'framer-motion';

const Returns = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <div className="min-h-screen bg-dark-400 pt-24 pb-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-6xl font-futuristic font-bold mb-6">
            <span className="gradient-text">Returns Policy</span>
          </h1>
        </motion.div>

        {/* Returns Policy Section */}
        <motion.section
          className="mb-16"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.div
            className="card-glass p-8 rounded-lg max-w-4xl mx-auto"
            variants={itemVariants}
          >
            <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
              <p>Returns are accepted within <span className="text-primary-400 font-semibold">24 hours</span> if the product is defective or not as described.</p>
              <p>Buyer must provide clear photos/video of the issue.</p>
              <p>Returns are not accepted for personal preference, minor differences in color, or normal wear and tear.</p>
            </div>
          </motion.div>
        </motion.section>
      </div>
    </div>
  );
};

export default Returns;
